import { projectFirestore } from '../../firebase/config'
import { useEffect, useState } from 'react'

import LessonList from '../../components/LessonList'

// styles
import '../journal/Journal.css'
import { useTheme } from '../../hooks/useTheme'

export default function Lessons() {
    const [data, setData] = useState(null)
    const [isPending, setIsPending] = useState(false)
    const [error, setError] = useState(false)
    const { mode } = useTheme()

    useEffect(() => {
        setIsPending(true)
        projectFirestore.collection("lessons").orderBy("order", "asc").get().then((snapshot)=> {
         if (snapshot.empty) {
             setError('No journals to load')
             setIsPending(false)
         } else {
             let results = []
             snapshot.docs.forEach(doc => {
                 results.push({ id: doc.id, ...doc.data() })
             })
             setData(results)
             setIsPending(false)
         }
        }).catch(err => {
            setError(err.message)
            setIsPending(false)
        })
    }, [])

    return (
        <div className={`layout-journal ${mode}`}>
            <div className='header'>
                <h1>Lesson Plans</h1>
                <p className='about'>A place where I document Computer Science Lesson plans. All plans layout a full lesson and the standards met by the lesson as well as the grade level of the lesson.</p>
            </div>
            {error && <p className='error'>{error}</p>}
            {isPending && <p className='loading'>Loading...</p>}
            {data && <LessonList lessons={data}/>}
        </div>
    )
}